import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Link } from "react-router-dom/cjs/react-router-dom.js";
import { Segment, Header, Icon } from "semantic-ui-react";

import SummaryPanelMap from "./SummaryPanelMap.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class SummaryPanel extends PureComponent {
  static propTypes = {
    config: PropTypes.object.isRequired,
    view: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.summary_panel"
  };

  // -- RENDER -- //

  renderPanels(panels) {
    const {
      projectId,
      config,
      violationErrors,
      formikProps,
      provider,
      region,
      zone,
      providersList,
      regionsList,
      zonesList
    } = this.props;

    const { configCopyKey } = config.copyKey || {};

    return panels.map(panel => {
      return (
        <SummaryPanelMap
          id={panel.id}
          type={panel.panelType}
          key={`panel-${panel.id}`}
          projectId={projectId}
          providersList={providersList}
          provider={provider}
          regionsList={regionsList}
          region={region}
          zonesList={zonesList}
          zone={zone}
          configCopyKey={configCopyKey}
          config={config}
          configOptions={panel.options}
          formikProps={formikProps}
          apiErrors={violationErrors}
          onComplete={this.onStepComplete}
        />
      );
    });
  }

  renderPanelBody() {
    const {
      id,
      config: { steps },
      copyKey,
      copy
    } = this.props;

    return (
      <Fragment>
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        {steps.map(step => {
          if (step.id !== id) {
            return (
              <Fragment key={step.id}>
                <Header
                  as="h4"
                  attached="top"
                  className="summary-panel-section"
                  block
                >
                  <Link to={step.id}>
                    <Icon name={step.icon}></Icon> {step.name}
                  </Link>
                </Header>
                <Segment attached>{this.renderPanels(step.panels)}</Segment>
              </Fragment>
            );
          }
        })}
      </Fragment>
    );
  }

  renderActive() {
    return this.renderPanelBody();
  }

  renderOptional() {
    return this.renderPanelBody();
  }

  renderInactive() {
    return null;
  }

  render() {
    const { view } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        return this.renderActive();
      case PANEL_STATES.OPTIONAL:
        return this.renderOptional();
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SummaryPanel);
